import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import * as ServiceslistActions from './Serviceslist.action';
import { NSAdminbuysellRuleserviceService } from '../../Clients/NS/Services/NSAdminbuysellRuleservice.service';

@Injectable()
export class ServiceslistEffects {
  loadServices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceslistActions.loadServices),
      mergeMap(() =>
        this.servicesService.GetServiceslist().pipe(
          map((services) =>
            ServiceslistActions.loadServicesSuccess({ services })
          ),
          catchError((error) =>
            of(
              ServiceslistActions.loadServicesFailure({ error: error.message })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private servicesService: NSAdminbuysellRuleserviceService
  ) {}
}
